/**
 * 为当前页面生命周期内的 HIDDevice 对象分配稳定 ID。
 * ID 只用于运行时归属，不写入持久化存储，也不替代固件唯一序列号。
 */
class HIDTransportRegistry {
  constructor(prefix = 'hid') {
    this.prefix = prefix;
    this.ids = new WeakMap();
    this.nextId = 1;
  }

  getId(device) {
    if (!device || (typeof device !== 'object' && typeof device !== 'function')) {
      return null;
    }
    let id = this.ids.get(device);
    if (!id) {
      id = `${this.prefix}-${this.nextId}`;
      this.nextId += 1;
      this.ids.set(device, id);
    }
    return id;
  }
}

export default HIDTransportRegistry;
